import axios from "axios";
import APIModel from "../../Models/APIModel";

export const getSiteGates = (token,SiteID) => {
  return axios.get(APIModel.HOST + "Admin/GetSiteGates?CSiteID="+SiteID,{
    'headers': {
      'Content-Type': 'application/json',
      'Accept':'application/json',
      'token':token
    }
  });
};

export const createGate = (token,params) => {
  return axios.post(APIModel.HOST + "Admin/CreateGate",params,{
    'headers': {
      'Content-Type': 'application/json',
      'Accept':'application/json',
      'token':token
    }
  });
};

export const editGate = (token,params) => {
  return axios.post(APIModel.HOST + "Admin/EditGate",params,{
    'headers': {
      'Content-Type': 'application/json',
      'Accept':'application/json',
      'token':token
    }
  });
};


export const deleteGate = (token,params) => {
  return axios.post(APIModel.HOST + "Admin/DeleteGate",params,{
    'headers': {
      'Content-Type': 'application/json',
      'Accept':'application/json',
      'token':token
    }
  });
};

